import { SearchInput } from "@carbon6/c6-frontend-design";
import { useSearchDraft } from "./useSearchDraft";
import styles from "./filterAnatomy.module.css";

type FilterSearchInputProps = {
  /** 커밋된 검색어. 축 상태의 소유자(URL 등)가 준다. */
  value: string;
  onCommit: (next: string) => void;
  ariaLabel: string;
  placeholder: string;
  disabled?: boolean;
};

/**
 * 목록 필터 바의 검색 입력. size 를 지정하지 않아 c6 기본(md)을 쓴다 — 행 1 의 다른 컨트롤과
 * 같은 높이여야 한 줄로 읽힌다(규칙 §13).
 */
export function FilterSearchInput({
  ariaLabel,
  disabled,
  onCommit,
  placeholder,
  value,
}: FilterSearchInputProps) {
  const { change, commitNow, draft } = useSearchDraft(value, onCommit);

  return (
    <div className={styles.search}>
      <SearchInput
        aria-label={ariaLabel}
        disabled={disabled}
        placeholder={placeholder}
        showClear
        value={draft}
        onSearch={(query) => commitNow(query)}
        onValueChange={change}
      />
    </div>
  );
}
